import { RMSelectProps } from 'business/models/CustomModels';
import React from 'react';
import './style.scss';

export default function RMSelect({
  options,
  selectedValue,
  onChange,
  style,
  placeholder,
  disabled = false,
  className = '',
  id = '',
}: RMSelectProps) {
  return (
    <select
      id={id != '' ? id : 'controls-rmselect-dropdown-wrapper'}
      data-testid={id != '' ? id : 'controls-rmselect-dropdown-wrapper'}
      placeholder={placeholder}
      value={selectedValue}
      onChange={onChange}
      style={{
        ...style,
        color: selectedValue === '' || selectedValue === '-1' ? '#c4c4c4' : '#000000',
      }}
      className={'rm-select ' + className}
      disabled={disabled}
    >
      <option
        id="controls-rmselect-placeholder-options"
        data-testid="controls-rmselect-placeholder-options"
        value="-1"
        disabled
        hidden
      >
        {placeholder || 'Select an option'}
      </option>
      {options?.map((item) => (
        <option
          id={`controls-rmselect-option-${item.name}`}
          data-testid={`controls-rmselect-option-${item.name}`}
          key={item.id}
          className="rm-select-option"
          value={item.id}
        >
          {item.name}
        </option>
      ))}
    </select>
  );
}
